import { createRouter, createWebHashHistory } from "vue-router";
import { useConfigStore } from "@/store/config";

import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import v404 from "../views/v404.vue";
import Access from "../views/Access.vue";
import Campaigns from "../views/Campaigns.vue";
import Streamers from "../views/Streamers.vue";
import Formats from "../views/Formats.vue";
import Reports from "../views/Reports.vue";
import Assets from "../views/Assets.vue";

const routes = [
     {
            path: "/",
            name: "Login",
            component: Login,
      },
      {
            path: "/home",
            name: "Home",
            component: Home,
      },
      {
            path: "/campaigns",
            name: "Campaigns",
            component: Campaigns,
      },
      {
            path: "/streamers",
            name: "Streamers",
            component: Streamers,
      },
      {
            path: "/formats",
            name: "Formats",
            component: Formats,
      },
      {
            path: "/reports",
            name: "Reports",
            component: Reports,
      },
      {
            path: "/assets",
            name: "Assets",
            component: Assets,
      },
      {
            path: "/access/:Uid",
            name: "Access",
            component: Access,
      },
      {
            path: "/:catchAll(.*)",
            name: "v404",
            component: v404,
      }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


router.beforeEach((to, from, next) => {
  const auth = useConfigStore();

  if (to.meta.requiresAuth && !auth.isLoggedIn) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;